import { Inject, Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { PageForRender } from 'render/render.models';
import { RenderSlugService } from 'render/services/render-slug.service';
import { RenderStateService } from 'render/services/render-state/render-state.service';
import { combineLatest } from 'rxjs';
import { map, distinctUntilChanged, filter, mergeMap, takeUntil } from 'rxjs/operators';
import { UnsubscribeComponent } from 'shared/directives/unsubscribe.component';
import { IdtComponent } from 'shared/models/idt-components/idt-component.models';
import { FragmentService, FRAGMENT_SERVICE_TOKEN } from 'shared/services/fragment-shared.service';


@Component({
  selector: 'piece-fragment-render',
  templateUrl: './piece-fragment-render.component.html',
  styleUrls: ['./piece-fragment-render.component.scss']
})
export class PieceFragmentRenderComponent
  extends UnsubscribeComponent
  implements OnInit {

  @Input() public piece: IdtComponent | undefined;
  @Input() public country: string | undefined;
  @Input() public lang: string | undefined;

  public children: IdtComponent[] = [];

  constructor(
    @Inject(FRAGMENT_SERVICE_TOKEN) public fragmentService: FragmentService,
    private readonly cd: ChangeDetectorRef,
    private readonly renderSlugService: RenderSlugService,
    private readonly renderStateService: RenderStateService
  ) {
    super();
  }

  public ngOnInit() {
    const slug = this.piece && this.piece.settings.general.slug;
    const pageSlug = this.renderSlugService.getSlug();
    const device$ = this.renderStateService.getDevice$(pageSlug);
    const timeTravelTo$ = this.renderStateService.getTimeTravelTo$(pageSlug);
    const userFlags$ = this.renderStateService.getUserFlags$(pageSlug);
    const page$ = combineLatest([device$, timeTravelTo$, userFlags$]).pipe(
      mergeMap(([device, timeTravelTo, userFlags]) => {
        return this.fragmentService.retrieveFragment(
          slug,
          this.country,
          this.lang,
          device || undefined,
          timeTravelTo || undefined,
          userFlags || undefined
        );
      }),
      // TODO: check FIXME at RenderFragmentService.retrieveFragment()
      map((page) => page as unknown as PageForRender),
      filter((page) => !!page?.content),
      takeUntil(this.clearSubscriptions$)
    );

    page$.subscribe((page) => {
      const content: IdtComponent[] = Object.entries(page.content)
        .filter(([key,]) => key !== '1') // Is there a better way to remove the layout?
        .map(([, value]) => value);
      this.renderStateService.updateComponents(pageSlug, content);
    });

    combineLatest([
      page$,
      this.renderStateService.getComponents$(pageSlug)
    ]).pipe(
      distinctUntilChanged(),
      map(([page,]) => {
        const children: string[] = (page && page.content && page.content['1'] && page.content['1'].children && page.content['1'].children['1']) || [];
        return children.map((childrenId) => page.content[childrenId]);
      }),
      takeUntil(this.clearSubscriptions$)
    ).subscribe((slices) => {
      this.children = slices;
      this.cd.markForCheck();
    });
  }

  public trackByIndex(index: number): number {
    return index;
  }

}
